var activeKey = 'active';
var themeCache = new Map();
themeCache.set(activeKey, null);
export var getThemeByKey = function getThemeByKey(key) {
  return themeCache.get(key);
};
export var setThemeByKey = function setThemeByKey(key, theme) {
  return themeCache.set(key, theme);
};
export var getActiveTheme = function getActiveTheme() {
  return getThemeByKey(activeKey);
};
export var setActiveTheme = function setActiveTheme(theme) {
  themeCache.set(activeKey, theme);
};